import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import QRCode from 'qrcode';

export const downloadQRCodesAsZip = async (qrCodes, fgColor = "#000000", bgColor = "#FFFFFF", logo = null, logoSize = 30) => {
  const zip = new JSZip();
  const qrFolder = zip.folder("qr-codes");

  // Create QR codes in parallel
  await Promise.all(
    qrCodes.map(async (qr, index) => {
      // Create QR code
      const canvas = document.createElement('canvas');
      canvas.width = 1024;
      canvas.height = 1024;

      await QRCode.toCanvas(canvas, qr.content, {
        width: 1024,
        margin: 1,
        color: {
          dark: fgColor,
          light: bgColor
        },
        errorCorrectionLevel: 'M'
      });

      // If logo is provided, add it to the canvas
      if (logo) {
        const ctx = canvas.getContext('2d');
        const img = new Image();
        await new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = reject;
          img.src = logo;
        });

        const logoWidth = Math.floor(1024 * (logoSize / 100));
        const logoHeight = logoWidth;
        const x = (1024 - logoWidth) / 2;
        const y = (1024 - logoHeight) / 2;

        // Draw white background for logo
        ctx.fillStyle = bgColor;
        ctx.fillRect(x, y, logoWidth, logoHeight);
        
        // Draw logo
        ctx.drawImage(img, x, y, logoWidth, logoHeight);
      }

      // Convert to PNG
      const pngData = canvas.toDataURL("image/png");
      const base64Data = pngData.replace(/^data:image\/png;base64,/, "");
      
      // Add to zip
      qrFolder.file(`qr-code-${index + 1}.png`, base64Data, { base64: true });
    })
  );

  // Generate and download zip
  const content = await zip.generateAsync({ type: "blob" });
  saveAs(content, "qr-codes.zip");
}; 